"use client";
import Container from "@/components/ui/Container";
import React, { useContext } from "react";
import { languageContext } from "@/contexts/language-context";
import confidentialityTranslation from "@/translation/confidentialityTranslation";
const Page = () => {
  const { lang } = useContext<any>(languageContext);
  return (
    <main className="bg-neutral-950">
      <Container className="py-[3rem] sm:py-[3rem]">
        <h1 className="text-3xl font-semibold mb-4">
          {confidentialityTranslation.title[lang]}
        </h1>

        <p className="mb-8">{confidentialityTranslation.subtitle[lang]}</p>

        <ul className="flex flex-col gap-8">
          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.oneTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.oneText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.twoTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray">
              {confidentialityTranslation.twoText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.threeTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray">
              {confidentialityTranslation.threeText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.fourTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray">
              {confidentialityTranslation.fourText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.fiveTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.fiveText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.sixTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.sixText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.sevenTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.sevenText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.eightTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.eightText[lang]}
            </p>
          </li>

          <li>
            <h3 className="text-xl font-semibold mb-2">
              {confidentialityTranslation.nineTitle[lang]}
            </h3>
            <p className="text-sm text-light-gray leading-[150%]">
              {confidentialityTranslation.nineText[lang]}
            </p>
          </li>
        </ul>
      </Container>
    </main>
  );
};

export default Page;
